module.exports = __webpack_public_path__ + "static/img/nuevos_05.1450c6ae.jpg";